//
//
//
//
//

export default {
  name: 'Cliente',
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/cliente/Cliente.vue?vue&type=script&lang=js&